<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <v-icon v-on="on">my_location</v-icon>
    </template>
    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>Select Location</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="clearLoc"><v-icon large>close</v-icon></v-btn>

          <v-btn icon @click="emit" :disabled="!changed || !valid"
            ><v-icon large color="primary">check</v-icon></v-btn
          >
        </v-toolbar-items>
      </v-toolbar>

      <v-textarea
        v-model="address"
        label="Address"
        class="mt-4 px-4 mx-4"
        auto-grow
        rows="2"
      />
      <div class="text-center overline">
        Lat: {{ lat | formatLatLng }} - Lng:
        {{ lng | formatLatLng }}
      </div>
      <v-container class="map fill-height">
        <l-map
          ref="map"
          v-resize="onResize"
          :zoom="10"
          :center="center"
          @click="getGeoLocation"
        >
          <l-control-layers />

          <l-tile-layer
            v-for="provider in tileProviders"
            :key="provider.id"
            :name="provider.name"
            :url="provider.url"
            layer-type="base"
          />
          <l-marker v-if="valid" :lat-lng="marker"></l-marker>
        </l-map>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import GeoLocationService from '@/services/geoLocation.service'
import { LMap, LTileLayer, LControlLayers, LMarker } from 'vue2-leaflet'

export default {
  name: 'LocationPicker',
  props: ['location'],
  components: { LMap, LTileLayer, LControlLayers, LMarker },
  data() {
    return {
      dialog: false,
      changed: false,

      address: this.location.address || '',
      lng: this.location.lng || null,
      lat: this.location.lat || null,

      // Map
      center: [39.614152077002664, 2.9108017578125004],
      tileProviders: [
        {
          id: 1,
          name: 'Open Street Map',
          url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
          attribution: 'OSM'
        },
        {
          id: 2,
          name: 'cartocdn',
          url:
            'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
          attribution:
            "&copy; <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a> &copy; <a href='https://carto.com/attributions'>CARTO</a>"
        },
        {
          id: 3,
          name: 'Esri World Map',
          url:
            'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
          attribution: 'Esri'
        },
        {
          id: 4,
          name: 'Esri World Imagery',
          url:
            'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
          attribution: 'Esri'
        }
      ],
      bounds: null
    }
  },

  computed: {
    marker() {
      return [this.lat, this.lng]
    },
    valid() {
      return !!this.lat && !!this.lng
    }
  },

  watch: {
    location() {
      this.clearLoc()
    }
  },

  methods: {
    async getGeoLocation(e) {
      try {
        const data = await GeoLocationService.getFromLatLng(e.latlng)
        // console.table(data.results)
        const loc = data.results[0]
        this.address = loc.formatted
        this.lat = e.latlng.lat
        this.lng = e.latlng.lng

        this.changed = true
      } catch (error) {
        console.log(error)
      }
    },
    onResize() {
      setTimeout(() => {
        this.$refs.map.mapObject.invalidateSize()
      }, 100);
    },

    clearLoc() {
      this.address = this.location.address || ''
      this.lat = this.location.lat || null
      this.lng = this.location.lng || null
      this.reset()
    },

    emit() {
      this.$emit('new_location', {
        address: this.address,
        lat: this.lat,
        lng: this.lng
      })
      this.reset()
    },

    reset() {
      this.dialog = false
      this.changed = false
    }
  }
}
</script>

<style lang="scss">
.map {
  height: 800px;
  width: 800px;
}
</style>
